<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('xlsx-to-pdf-converter', 'XLSX → PDF');

function handleBatchCreated(batchId: string) {
  console.log('[XLSX Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[XLSX Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[XLSX Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[XLSX Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[XLSX Converter] Credits updated:', credits);
}
</script>
